/** @jsxImportSource @emotion/react */
import { Pages } from 'modules/navigation/domain/enums/pages';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useIsAdmin } from 'shared/hooks/use-is-admin';
import { history } from 'store/store';
import UDButton from '../../../../ud-ui/components/button';
import Stars from '../../../../ud-ui/components/icon/stars';
import UDText from '../../../../ud-ui/components/text';
import { selectActiveBoard } from '../../../store/templates/selectors';
import useCopyModal from '../../hooks/modals/catalog/copy';
import { buttonCss, MainBlock } from './styles';

interface IProps {
  templateId: number;
}

function Header(props: IProps) {
  const { templateId } = props;
  const activeBoard = useSelector(selectActiveBoard);

  const isAdmin = useIsAdmin();

  const onGoEdit = useCallback(() => {
    if (!activeBoard) {
      throw Error('activeBoard is undefined');
    }
    if (!isAdmin) {
      throw Error('user is not super admin');
    }

    history.push(Pages.TEMPLATE.builders.editor(templateId, activeBoard.id), { from: 'catalog' });
  }, [activeBoard, isAdmin, templateId]);

  const { modal: copyModal, open: onOpenCopy } = useCopyModal(templateId);
  return (
    <MainBlock>
      <div className={'flex-center'}>
        <Stars style={{ minWidth: 52 }} />
        <UDText className={'ml-2'} type={'subhead'}>
          Для редактирования этого шаблона необходимо сделать копию
        </UDText>
      </div>
      <div className={'flex justify-end'} style={{ gap: 20 }}>
        {isAdmin && (
          <UDButton css={buttonCss} variant={'light'} onClick={onGoEdit}>
            Редактировать
          </UDButton>
        )}
        <UDButton css={buttonCss} variant={'light'} onClick={onOpenCopy}>
          Скопировать
        </UDButton>
      </div>
      {copyModal}
    </MainBlock>
  );
}

export default Header;
